// extracted by mini-css-extract-plugin
export default {"DraggableCard":"bga_a"};